var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2531 17.032C31.211 16.9368 17.2343 30.5489 17.1392 47.5659L17.1392 47.5734C16.9489 64.6033 30.6491 78.5854 47.6724 78.6805L47.6799 78.6806C64.7093 78.8709 78.6911 65.1703 78.7862 48.1465L78.7863 48.1391C78.9766 31.1092 65.2763 17.1271 48.2531 17.032ZM14.4674 47.5473C14.5729 29.031 29.7771 14.2569 48.268 14.3602C66.7777 14.4636 81.663 29.662 81.458 48.1656C81.3524 66.6738 66.1552 81.5572 47.6533 81.3523C29.1456 81.2467 14.2627 66.0493 14.4674 47.5473Z",
    fill: "#FFC78F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0292 52.8049C45.2303 52.8049 43.0312 50.6058 43.0312 47.907V47.807C43.0312 45.1081 45.2304 42.9091 47.9292 42.9091H48.0292C50.728 42.9091 52.9271 45.1081 52.9271 47.807V47.907C52.9271 50.6058 50.728 52.8049 48.0292 52.8049Z",
    fill: "#FFC78F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.91 52.8049C64.1112 52.8049 61.9121 50.6058 61.9121 47.907V47.807C61.9121 45.1081 64.1112 42.9091 66.8101 42.9091H66.91C69.6089 42.9091 71.808 45.1081 71.808 47.807V47.907C71.808 50.6058 69.6089 52.8049 66.91 52.8049Z",
    fill: "#FFC78F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1483 52.8049C26.3495 52.8049 24.1504 50.6058 24.1504 47.907V47.807C24.1504 45.1081 26.3495 42.9091 29.0484 42.9091H29.1483C31.8472 42.9091 34.0463 45.1081 34.0463 47.807V47.907C34.0463 50.6058 31.8472 52.8049 29.1483 52.8049Z",
    fill: "#FFC78F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.f1f9d5113c38583356b1d3e6f01a53f4.svg";
export { ForwardRef as ReactComponent };